<template>
  <div>
    <sweet-modal :title="activeIndex ? $t('modal_createProject') : $t('modal_createProject_selectProjectTemplate')" blocking width="780px" ref="createProject" class="modal" v-on:close="close">
      <form-wizard
        shape="tab"
        ref="wizard"
        :start-index="0"
        step-size="xs"
        :color="color"
        @on-change="handleTabChange"
        @on-validate="handleValidation"
        error-color="#f56c6c"
        validate-on-back
        title=""
        subtitle=""
        @on-complete="onComplete">
        <tab-content title="Select template"
                      icon="el-icon-edit-outline">
          <el-row :span="24" :gutter="20">
            <el-col :span="8">
              <el-radio-group v-model="formCreateProject.projectTemplateId">
                <el-row style="padding-bottom:5px;" v-for="item in formCreateProject.projectTemplates" :key="item.id">
                  <el-radio :label="item.id" @change="selectTemplate">{{item.name}}</el-radio>
                </el-row>
              </el-radio-group>
            </el-col>
            <el-col :span="16">
              <div>
                <img style="width:100%" :src="templateImgSrc" alt="template-img">
              </div>
            </el-col>
          </el-row>
        </tab-content>
        <tab-content title="Settings"
                      icon="el-icon-check">

            <el-form :model="formCreateProject" status-icon :rules="rules" ref="formCreateProject" label-position="left" label-width="0px" class="demo-ruleForm">
              <!-- add -->
              <el-row :gutter="20">
                <el-col :span="14" :offset="0">
                  <!-- label-width="60px" :label="$t('modal_name')" -->
                  <el-form-item size="mini" prop="projectName">
                    <el-input :label="$t('modal_projectName')" v-model="formCreateProject.projectName"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="10" :offset="0">
                  <!-- label-width="70px" :label="$t('modal_region')" -->
                  <el-form-item size="mini" prop="regionId">
                    <el-select v-model="formCreateProject.regionId" :placeholder="$t('modal_projectRegion')" filterable style="width: 100%;">
                      <el-option
                        v-for="regions in formCreateProject.region"
                        :key="regions.id"
                        :label="regions.name"
                        :value="regions.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row :gutter="20">
                <el-col :span="14" :offset="0">
                  <!-- label-width="60px" :label="$t('modal_date')" -->
                  <el-form-item size="mini" prop="Date">
                    <el-date-picker
                      v-model="formCreateProject.Date"
                      type="datetimerange"
                      prefix-icon="el-icon-date"
                      align="center"
                      range-separator=""
                      :start-placeholder="$t('modal_startDate')"
                      :end-placeholder="$t('modal_endDate')"
                      format="d MMM yy h:mm a"
                      value-format="timestamp"
                      style="width: 100%;">
                    </el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="10" :offset="0">
                  <el-form-item size="mini" prop="projectTypeId">
                    <el-select v-model="formCreateProject.projectTypeId" :placeholder="$t('modal_projectType')" style="width: 100%;">
                      <el-option
                        v-for="type in formCreateProject.projectType"
                        :key="type.id"
                        :label="type.name"
                        :value="type.id"
                        @click.native="handleSelectType(type.stages)"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row :gutter="20">
                <el-col :span="14" :offset="0" style="margin-bottom: -20px;">
                  <!-- label-width="60px" :label="$t('modal_billing')" -->
                  <el-form-item>
                    <el-col :span="24">
                      <el-radio-group v-model="formCreateProject.bill">
                        <el-radio :label="0">{{$t('modal_billing_single')}}</el-radio>
                        <el-radio :label="1">{{$t('modal_billing_progress')}}</el-radio>
                        <el-radio :label="2">{{$t('modal_billing_notBillable')}}</el-radio>
                      </el-radio-group>
                    </el-col>
                  </el-form-item>
                </el-col>
                <el-col :span="10" :offset="0">
                  <!-- label-width="70px" :label="$t('modal_phase')" -->
                  <el-form-item size="mini" prop="projectStageId" >
                    <el-select v-model="formCreateProject.projectStageId" :placeholder="$t('modal_projectPhase')" style="width: 100%;">
                      <el-option
                        v-for="stage in formCreateProject.projectStage"
                        :key="stage.id"
                        :label="stage.name"
                        :value="stage.id"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row :gutter="20">
                <el-col :span="14" :offset="0">
                  <el-form-item size="mini">
                    <el-input :label="$t('modal_projectEmail')" v-model="formCreateProject.projectEmail"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="10" :offset="0">
                  <!-- label-width="70px" :label="$t('modal_priority')" -->
                  <el-form-item size="mini" prop="projectPriorityId">
                    <el-select v-model="formCreateProject.projectPriorityId" :placeholder="$t('modal_projectPriority')" style="width: 100%;">
                      <el-option
                        v-for="priority in formCreateProject.projectPriority"
                        :key="priority.id"
                        :label="$t(priority.translationKey)"
                        :value="priority.id"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row :gutter="20">
                <el-col :span="14" :offset="0">
                  <br>
                </el-col>
                <el-col :span="10" :offset="0">
                  <!-- label-width="70px" :label="$t('modal_status')" -->
                  <el-form-item size="mini" prop="projectStatusId">
                    <el-select v-model="formCreateProject.projectStatusId" :placeholder="$t('modal_projectStatus')" style="width: 100%;">
                      <el-option
                        v-for="status in formCreateProject.projectStatus"
                        :key="status.id"
                        :label="$t(status.translationKey)"
                        :value="status.id"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>


              <el-row>
                <el-col :span="24" :offset="0">
                  <el-form-item>
                    <el-checkbox v-model="formCreateProject.isAddressAssigned">{{$t('modal_projectAddress')}}</el-checkbox>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row :gutter="20" v-if="formCreateProject.isAddressAssigned">
                <el-col :span="12" :offset="0">
                  <el-form-item size="mini" prop="countryId">
                    <el-select v-model="formCreateProject.countryId" filterable :placeholder="$t('modal_country')" style="width: 100%;">
                      <el-option
                        filterable
                        v-for="country in formCreateProject.country"
                        :key="country.id"
                        :label="country.name"
                        :value="country.id"
                        @click.native="setState(country.id)"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12" :offset="0">
                  <el-form-item size="mini">
                    <el-select no-data-text="no date" v-model="formCreateProject.stateId" :placeholder="$t('modal_state')" filterable style="width: 100%;">
                      <el-option
                        v-for="item in formCreateProject.state"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                        @click.native="setCity(item.id)">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row :gutter="20" v-if="formCreateProject.isAddressAssigned">
                <el-col :span="12" :offset="0">
                  <el-form-item size="mini">
                    <el-select no-data-text="no date" v-model="formCreateProject.cityId" :placeholder="$t('modal_city')" filterable style="width: 100%;">
                      <el-option
                        v-for="item in formCreateProject.cities"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12" :offset="0">
                  <el-form-item size="mini" prop="postCode">
                    <el-input :placeholder="$t('modal_postCode')" v-model="formCreateProject.postCode"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row :gutter="20" v-if="formCreateProject.isAddressAssigned">
                <el-col :span="12" :offset="0">
                  <el-form-item size="mini">
                    <el-input :label="$t('modal_address_line_1')" v-model="formCreateProject.address"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12" :offset="0">
                  <el-form-item size="mini">
                    <el-input :label="$t('modal_address_line_2')" v-model="formCreateProject.address2"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row :gutter="20" v-if="formCreateProject.isAddressAssigned">
                <el-col :span="12" :offset="0">
                  <el-form-item size="mini">
                    <el-input :label="$t('modal_address_line_3')" v-model="formCreateProject.address3"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12" :offset="0">

                </el-col>
              </el-row>

              <div class="modal__btnDesc">
                  <el-button style="width: 100%;" slot="button" v-on:click="$refs.nestedChild.open()" size="medium" type="primary" plain>{{$t('modal_aboutThisProject')}}</el-button>
              </div>

              <el-row :gutter="20">
                <el-col :span="14" :offset="0">
                  <!-- label-width="160px" :label="$t('modal_projectOwner')" -->
                  <el-form-item prop="businessUnitId" size="mini">
                    <el-select v-model="formCreateProject.businessUnitId" :placeholder="$t('modal_projectOwner')" style="width: 100%;">
                      <el-option
                        v-for="bu in formCreateProject.businessUnitList"
                        :key="bu.id"
                        :label="bu.name"
                        :value="bu.id"
                        @click.native="handleSelectBu(bu.id, bu.leaderBU)"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="10" :offset="0">
                  <!-- label-width="90px" :label="$t('modal_leader')" -->
                  <el-form-item  prop="projectLeaderId" size="mini">
                    <el-select disabled v-model="formCreateProject.projectLeaderId" :placeholder="$t('modal_projectLeader')" style="width: 100%;">
                      <el-option
                        v-for="leader in formCreateProject.projectLeader"
                        :key="leader.id"
                        :label="leader.user.fullName"
                        :value="leader.id"
                        :class="{ disabled: leader.status != 1 }"
                        @click.native="handleSelectLeader(leader.id, leader.businessUnitId)"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row :gutter="20">
                <el-col :span="14">
                  <!-- label-width="160px" :label="$t('modal_projectBU')" -->
                  <el-form-item prop="projectTeamBuId" size="mini">
                    <el-select no-data-text="no date" @remove-tag="removeBuTag" v-model="formCreateProject.projectTeamBuId" multiple :placeholder="$t('modal_businessUnits')" style="width: 100%;">
                      <el-option
                        v-for="item in formCreateProject.businessUnitList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                        @click.native="handleSelectTeamBu(item.id, item.leaderBU)"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="10">
                  <!-- label-width="90px" :label="$t('modal_BUManagers')" -->
                  <el-form-item prop="projectTeamId" size="mini">
                    <el-select disabled no-data-text="no date" @remove-tag="removeTag" v-model="formCreateProject.projectTeamId" multiple :placeholder="$t('modal_managementTeam')" style="width: 100%;">
                      <el-option
                        v-for="item in formCreateProject.projectTeam"
                        :key="item.id"
                        :label="item.user.fullName"
                        :value="item.id"
                        :class="{ disabled: item.status != 1 }"
                        @click.native="handleSelectTeam(item.id)"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row :gutter="20">
                <el-col :span="14" :offset="0">
                  <br>
                </el-col>
                <el-col :span="10" :offset="0">
                  <!-- label-width="60px" -->
                  <el-form-item size="mini">
                    <el-switch active-color="#13ce66" v-model="formCreateProject.notifyTeam"></el-switch> {{$t('modal_notifyBUManagers')}}
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row :gutter="20">
                <el-col :span="14">
                  <!-- label-width="60px" :label="$t('modal_clients')" -->
                  <el-form-item prop="projectClientsId" size="mini">
                    <el-select no-data-text="no date" v-model="formCreateProject.projectClientsId" multiple :placeholder="$t('modal_projectClients')" style="width: 100%;">
                      <el-option
                        v-for="item in formCreateProject.projectClients"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="10">
                  <!-- label-width="60px" -->
                  <el-form-item size="mini">
                    <el-switch active-color="#13ce66" v-model="formCreateProject.notifyClients"></el-switch> {{$t('modal_notifyProjectClients')}}
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row :gutter="20">
                <el-col :span="14">
                  <!-- label-width="60px" :label="$t('modal_vendors')" -->
                  <el-form-item prop="projectVendorsId" size="mini">
                    <el-select no-data-text="no date" v-model="formCreateProject.projectVendorsId" multiple :placeholder="$t('modal_projectVendors')" style="width: 100%;">
                      <el-option
                        v-for="item in formCreateProject.projectVendors"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="10">
                  <!-- label-width="60px" -->
                  <el-form-item size="mini">
                    <el-switch active-color="#13ce66" v-model="formCreateProject.notifyVendors"></el-switch> {{$t('modal_notifyProjectVendors')}}
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row :gutter="20">
                <el-col :span="14">
                  <!-- label-width="60px" :label="$t('modal_partners')" -->
                  <el-form-item prop="projectPartners" size="mini">
                    <el-tooltip :content="$t('modal_inDevelopment')" placement="top">
                      <el-select disabled v-model="formCreateProject.partnerId" :placeholder="$t('modal_projectPartners')" style="width: 100%;">
                        <el-option
                          v-for="item in formCreateProject.partners"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id"
                        ></el-option>
                      </el-select>
                    </el-tooltip>
                  </el-form-item>
                </el-col>
                <el-col :span="10">
                  <!-- label-width="60px" -->
                  <el-form-item size="mini">
                    <el-switch active-color="#13ce66" v-model="formCreateProject.notifyPartners"></el-switch> {{$t('modal_notifyProjectPartners')}}
                  </el-form-item>
                </el-col>
              </el-row>

            </el-form>

        </tab-content>
        <el-button size="medium" type="primary" slot="prev">{{$t('general_back')}}</el-button>
        <el-button size="medium" type="primary" slot="next">{{$t('general_next')}}</el-button>
        <el-button size="medium" type="primary" slot="finish">{{$t('general_submit')}}</el-button>
      </form-wizard>
    </sweet-modal>
    <sweet-modal blocking ref="nestedChild">
      <vue2-custom-editor
          ref="editor"
          v-model="formCreateProject.aboutThisProject"
          style="margin-bottom: 20px;">

      </vue2-custom-editor>
      <div class="modal__btn">
        <el-button size="medium" v-if="projectState === 'add'" v-on:click="$refs.nestedChild.close()" type="primary">{{$t('general_submit')}}</el-button>
        <el-button size="medium" v-else @click="modalCancel('createProject')">{{$t('general_ok')}}</el-button>
      </div>
    </sweet-modal>

    <sweet-modal title="Adjust Permissions" width="500" blocking ref="permissions">
      <div class="permissions">
        <div>Need to adjust Team (User) permissions?</div>
        <div>Go to the Info Tab and select Permissions</div>
        <br>
        <div>For more information click on the link below</div>
        <div><a href="https://totalflow.io/permissions" target="_blank">www.totalflow.io/permissions</a></div>
      </div>
    </sweet-modal>
  </div>
</template>

<script>
  import Multiselect from 'vue-multiselect'
  import { SweetModal } from '@totalflow4/tfsweet-modal-vue'
  import axios from 'axios'
  import Vue2CustomEditor from "../vue-2-custom-editor";


  export default {
    name: "CreateProjectModal",
    components:{
      Vue2CustomEditor,
      SweetModal,
      Multiselect
    },
    data(){
      return {
        color:'rgb(52, 152, 219)',
        templateImgSrc: 'https://dev.totalflow.io/downloads/2020/12/17/849f4ea59c2b133d16c6a0489ebdc9fc.png',
        projectState: 'add',
        activeIndex: 0,
        formCreateProject: {
          bill: 0,
          isAddressAssigned: false,
          regionId: '',
          region: [],
          projectNo: '',
          projectName:'',
          aboutThisProject: null,

          projectStageId: '',
          projectStage: [],
          projectTypeId: '',
          projectType: [],
          projectPriorityId: '',
          projectPriority: [],
          projectStatusId: '',
          projectStatus: [],
          countryId: null,
          country: [],
          stateId:null,
          state: [],
          cityId: null,
          cities: [],
          address: '',
          address2: '',
          address3: '',
          projectTemplate: 'Clean project',
          postCode: null,

          startDate: '',
          deadlineDate: '',

          Date: [],

          projectLeaderId: '',
          projectLeader: [],

          businessUnitId: '',
          businessUnitName: '',
          projectTeamBuId: '',
          businessUnitList: [],
          businessUnitListLeader: [],

          notifyTeam: true,
          notifyClients: false,
          notifyVendors: false,
          notifyPartners: false,

          projectTeamId: [],
          projectTeam: [],
          projectClientsId: [],
          projectClients: [],
          projectVendorsId: [],
          projectVendors: [],
          projectPartners: '',
          projectTaskTree: '',
          projectTemplateId: '0',
          projectTemplates:[{
            name: this.$t('modal_createProject_buildNewTaskTree'),
            id: '0'
          }],
          partners:'',
          partnerId:[]
        },
        pickerOptions2: {
          shortcuts: [{
            text: 'Last week',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: 'Last month',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: 'Last 3 months',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
        rules: {
          regionId: [
            { required: true, message: 'Please input Region', trigger: 'change' }
          ],
          projectName: [
            { required: true, message: 'Please input Project name', trigger: 'blur' }
          ],
          projectStageId: [
            { required: true, message: 'Please input Project Stage', trigger: 'change' }
          ],
          businessUnitId: [
            { required: true, message: 'Please input Business Unit', trigger: 'change' }
          ],
          projectTeamBuId: [
            { required: true, message: 'Please input Business Unit team', trigger: 'blur' }
          ],
          projectPriorityId: [
            { required: true, message: 'Please input Project Priority', trigger: 'change' }
          ],
          projectStatusId: [
            { required: true, message: 'Please input Project Status', trigger: 'change' }
          ],
          Date: [
            { required: true, message: 'Please pick a date', trigger: 'blur' }
          ],
          // projectLeaderId: [
          //   { required: true, message: 'Please pick a Project Leader', trigger: 'blur' }
          // ]
          projectTypeId: [
            { required: true, message: 'Please input Project Type', trigger: 'change' }
          ],
        },
      }
    },
    methods: {
      handleSelectType(arrStages) {
        this.formCreateProject.projectStageId = ''
        this.formCreateProject.projectStage = arrStages
      },
      openModal(){
        this.createProjectOpen('add');
        this.$refs.createProject.open();
      },
      handleTabChange(prevIndex, nextIndex){
        console.log('OnChange', prevIndex, 'nextIndex', nextIndex)
        this.activeIndex = nextIndex;
      },
      handleValidation: function(isValid, tabIndex){
        // console.log('Tab: '+tabIndex+ ' valid: '+isValid)
      },
      handleSelectBu(businessUnitId, leaderBu) {
        console.log('businessUnitId', businessUnitId);

        // set leader to leader input
        this.formCreateProject.projectLeaderId = leaderBu.id;

        const even = (element) => element === businessUnitId;
        const ifBuInTeam = this.formCreateProject.projectTeamBuId.some(even);
        if (!ifBuInTeam) {
          this.formCreateProject.projectTeamBuId.push(businessUnitId);

          // set manager to manager list
          const evenManagers = (element) => element === leaderBu.id;
          const ifUserInManagers = this.formCreateProject.projectTeamId.some(evenManagers);

          if (!ifUserInManagers) {
            this.formCreateProject.projectTeamId.push(leaderBu.id);

          }
          console.log('manager', leaderBu)


        }
      },
      selectTemplate(templateId){
        const selectedTemplate = this.formCreateProject.projectTemplates.filter(val => val.id === templateId);
        this.templateImgSrc = selectedTemplate[0].template_img_url ? selectedTemplate[0].template_img_url : 'https://dev.totalflow.io/downloads/2020/12/17/849f4ea59c2b133d16c6a0489ebdc9fc.png';
        console.log(selectedTemplate)
      },
      onComplete: function(){
        this.createProjectSubmit('formCreateProject')
      },
      createProjectOpen(state) {
        let loader = this.$loading.show();
        let operation = ''
        if(state === 'add'){
          operation = 'create'
        }else if (state === 'edit'){
          operation = 'update'
        }
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/projects/directories?companyId=${this.$route.query.companyId || this.myFirstCompanys[0].id}&operation=${operation}`)
          .then(response => {
            for (let i = 0; i < response.data.projectTemplateList.length; i++){
              this.formCreateProject.projectTemplates.push(response.data.projectTemplateList[i])
            }
            console.log('---', response.data);
            this.formCreateProject.region = response.data.projectRegionList;
            // this.formCreateProject.projectStage = response.data.companyStageList;
            this.formCreateProject.projectType = response.data.companyTypeWithStageList
            this.formCreateProject.projectPriority = response.data.priorityList;
            this.formCreateProject.projectStatus = response.data.projectStatusList;
            this.formCreateProject.country = response.data.countryList;
            this.formCreateProject.projectClients = response.data.companyClientList;
            this.formCreateProject.projectVendors = response.data.companyVendorList;
            this.formCreateProject.businessUnitList = response.data.businessUnitList;

            this.formCreateProject.businessUnitId = Number(this.$route.query.businessUnitId);
            this.formCreateProject.businessUnitListLeader = response.data.businessUnitList.filter(val => val.id.toString() === this.$route.query.businessUnitId.toString());

            this.formCreateProject.projectLeader = response.data.companyUserList;
            this.formCreateProject.projectLeaderId = response.data.businessUnitList.filter(val => val.id.toString() === this.$route.query.businessUnitId.toString())[0].leaderBU.id;

            this.formCreateProject.projectTeamBuId.push(Number(this.$route.query.businessUnitId));
            this.formCreateProject.projectTeamId.push(response.data.businessUnitList.filter(val => val.id.toString() === this.$route.query.businessUnitId.toString())[0].leaderBU.id);
            this.formCreateProject.projectTeam = response.data.companyUserList;

            if(this.projectState === 'add'){
              this.formCreateProject.regionId = response.data.projectRegionList[0].id;
              // this.formCreateProject.projectStageId = response.data.companyStageList[1].id;
              this.formCreateProject.projectPriorityId = response.data.priorityList[1].id;
              this.formCreateProject.projectStatusId = response.data.projectStatusList[0].id;
              // this.formCreateProject.countryId = response.data.countryList[0].id

              this.formCreateProject.businessUnitId = response.data.businessUnitList.filter(val => val.id.toString() === this.$route.query.businessUnitId.toString())[0].id;
              // this.formCreateProject.businessUnitName = response.data.businessUnitList.filter(val => val.id.toString() === this.$route.query.businessUnitId.toString())[0].name;
              // this.formCreateProject.projectTeamId.push(response.data.companyUserList.filter(val => val.businessUnitId.toString() === this.$route.query.businessUnitId.toString())[0].id)
            }
            loader.hide();
            if(this.projectState === 'edit'){
              this.getProjectItem()
            }else{
              loader.hide()
            }
            this.$nextTick(() => {
              this.$refs.editor.setImagesState()
            })
          })
          .catch(error => {
            console.log('An error occurred:', error);
            loader.hide()
          });
      },
      setState(id, edit) {
        let loader = this.$loading.show();
        if(!edit){
          this.formCreateProject.stateId = null;
          this.formCreateProject.cityId = null;
          this.formCreateProject.cities = []
        }
        if(id !== null){
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
            .post(`/api/v1/projects/directories?companyId=${this.$route.query.companyId}&operation=getStateList&countryId=${id}`)
            .then(response => {
              loader.hide()
              console.log("ssssss", response)
              this.formCreateProject.state = response.data.stateList
            })
            .catch(error => {
              loader.hide()
              this.notification("Notification", error.response.data.message, "warning");
              console.log('An error occurred:', error);
            });
        }
        loader.hide()
      },
      setCity(id, edit) {
        let loader = this.$loading.show();
        if(!edit){
          this.formCreateProject.cityId = null
        }
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/projects/directories?companyId=${this.$route.query.companyId}&operation=getCityList&stateId=${id}`)
          .then(response => {
            loader.hide()
            console.log('---/companyClients/directories', response.data);
            this.formCreateProject.cities = response.data.cityList
          })
          .catch(error => {
            loader.hide()
            this.notification("Notification", error.response.data.message, "warning")
            console.log('An error occurred:', error);
          });
      },
      createProjectSubmit(form) {
        console.log('---', 'submit create', form);

        this.$refs[form].validate((valid) => {
          if (valid) {
            if (this.formCreateProject.isAddressAssigned == true) {
              if (this.formCreateProject.countryId &&
                this.formCreateProject.stateId &&
                this.formCreateProject.cityId) {
                let loader = this.$loading.show();
                axios
                  .post(`/api/v1/projects/create?companyId=${this.$route.query.companyId}`, {
                    // companyId: this.$route.query.companyId,
                    name: this.formCreateProject.projectName,
                    projectEmail: this.formCreateProject.projectEmail,
                    description: this.formCreateProject.aboutThisProject,
                    countryId: this.formCreateProject.countryId,
                    stateId: this.formCreateProject.stateId,
                    cityId: this.formCreateProject.cityId,
                    projectRegionId: this.formCreateProject.regionId,
                    companyStageId: this.formCreateProject.projectStageId,
                    priorityId: this.formCreateProject.projectPriorityId,
                    projectStatusId: this.formCreateProject.projectStatusId,
                    notifyTeam: this.formCreateProject.notifyTeam,
                    notifyClients: this.formCreateProject.notifyClients,
                    notifyVendors: this.formCreateProject.notifyVendors,
                    leaderCompanyUserId: this.formCreateProject.projectLeaderId,
                    companyUserIdList: this.formCreateProject.projectTeamId,
                    businessUnitIdLeader: this.formCreateProject.businessUnitId,
                    businessUnitIdManagerArr: this.formCreateProject.projectTeamBuId,
                    companyClientIdList: this.formCreateProject.projectClientsId,
                    companyVendorIdList: this.formCreateProject.projectVendorsId,
                    notifyPartners: this.formCreateProject.notifyPartners,
                    startDate: this.formCreateProject.Date[0],
                    deadlineDate: this.formCreateProject.Date[1],
                    postCode: this.formCreateProject.postCode,
                    projectTemplateId: this.formCreateProject.projectTemplateId,
                    // street: this.formCreateProject.street,
                    address: this.formCreateProject.address,
                    address2: this.formCreateProject.address2,
                    address3: this.formCreateProject.address3,
                    isAddressAssigned: this.formCreateProject.isAddressAssigned,
                    bill: this.formCreateProject.bill,
                    companyTypeId: this.formCreateProject.projectTypeId,
                  })
                  .then(response => {
                    // Handle success.
                    if (this.$refs.editor.uploadedImagesArray.length) {
                      this.$store.dispatch('approveUploadedImages', {
                        fileUrlArr: this.$refs.editor.uploadedImagesArray,
                        entityId: response.data.projectId,
                        entityTypeId: 1 // project about entity
                      })
                    }
                    this.$store.dispatch('getMenuStatistics');
                    this.$store.dispatch('getBusinessUnitProjectsList', this.$route.query.businessUnitId);
                    this.$refs.createProject.close();
                    this.notification("Success", "Create Project", "success");
                    loader.hide();
                    this.$emit('submit', response.data.projectId, this.formCreateProject.regionId, this.formCreateProject.projectStageId, 'first')
                    this.$refs.permissions.open()
                  })
                  .catch(error => {
                    // Handle error.
                    console.log('An error occurred:', error);
                    loader.hide()
                  });
              } else {
                this.$notify({
                  title: 'Notification',
                  message: 'Enter all fields Projects Address',
                  type: 'info'
                });
              }
            } else {
              this.formCreateProject.countryId = null;
              this.formCreateProject.stateId = null;
              this.formCreateProject.cityId = null;
              this.formCreateProject.postCode = null;
              this.formCreateProject.address = '';
              this.formCreateProject.address2 = '';
              this.formCreateProject.address3 = '';

              let loader = this.$loading.show();
              axios
                .post(`/api/v1/projects/create?companyId=${this.$route.query.companyId}`, {
                  // companyId: this.$route.query.companyId,
                  name: this.formCreateProject.projectName,
                  projectEmail: this.formCreateProject.projectEmail,
                  description: this.formCreateProject.aboutThisProject,
                  countryId: this.formCreateProject.countryId,
                  stateId: this.formCreateProject.stateId,
                  cityId: this.formCreateProject.cityId,
                  projectRegionId: this.formCreateProject.regionId,
                  companyStageId: this.formCreateProject.projectStageId,
                  priorityId: this.formCreateProject.projectPriorityId,
                  projectStatusId: this.formCreateProject.projectStatusId,
                  notifyTeam: this.formCreateProject.notifyTeam,
                  notifyClients: this.formCreateProject.notifyClients,
                  notifyVendors: this.formCreateProject.notifyVendors,
                  leaderCompanyUserId: this.formCreateProject.projectLeaderId,
                  businessUnitIdLeader: this.formCreateProject.businessUnitId,
                  businessUnitIdManagerArr: this.formCreateProject.projectTeamBuId,
                  companyUserIdList: this.formCreateProject.projectTeamId,
                  companyClientIdList: this.formCreateProject.projectClientsId,
                  companyVendorIdList: this.formCreateProject.projectVendorsId,
                  notifyPartners: this.formCreateProject.notifyPartners,
                  startDate: this.formCreateProject.Date[0],
                  deadlineDate: this.formCreateProject.Date[1],
                  postCode: this.formCreateProject.postCode,
                  projectTemplateId: this.formCreateProject.projectTemplateId,
                  // street: this.formCreateProject.street,
                  address: this.formCreateProject.address,
                  address2: this.formCreateProject.address2,
                  address3: this.formCreateProject.address3,
                  isAddressAssigned: this.formCreateProject.isAddressAssigned,
                  bill: this.formCreateProject.bill,
                  companyTypeId: this.formCreateProject.projectTypeId,
                })
                .then(response => {
                  // Handle success.
                  if (this.$refs.editor.uploadedImagesArray.length) {
                    this.$store.dispatch('approveUploadedImages', {
                      fileUrlArr: this.$refs.editor.uploadedImagesArray,
                      entityId: response.data.projectId,
                      entityTypeId: 1 // project about entity
                    })
                  }
                  this.$store.dispatch('getMenuStatistics');
                  this.$store.dispatch('getBusinessUnitProjectsList', this.$route.query.businessUnitId);
                  this.$refs.createProject.close();
                  this.notification("Success", "Create Project", "success");
                  loader.hide();
                  this.$emit('submit', response.data.projectId, this.formCreateProject.regionId, this.formCreateProject.projectStageId, 'first')
                  this.$refs.permissions.open()
                })
                .catch(error => {
                  // Handle error.
                  console.log('An error occurred:', error);
                  loader.hide()
                });
            }
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      handleSelectLeader(leaderId, businessUnitId){
        console.log('businessUnitId', businessUnitId);
        const even = (element) => element === leaderId;
        const ifUserInTeam = this.formCreateProject.projectTeamId.some(even);
        if (!ifUserInTeam) {
          this.formCreateProject.projectTeamId.push(leaderId)
        }
        this.formCreateProject.businessUnitId = businessUnitId
        // this.formCreateProject.businessUnitName = this.formCreateProject.businessUnitList.filter(val => val.id === businessUnitId)[0].name
      },
      removeBuTag(businessUnitId) {
        if(this.formCreateProject.businessUnitId === businessUnitId) {
          this.formCreateProject.businessUnitId = null;
          this.formCreateProject.projectLeaderId = null
        }

        this.formCreateProject.projectTeamId = [];

        let arrayOfLeadersId = [];

        this.formCreateProject.projectTeamBuId.forEach(buId => {
          const leader = this.formCreateProject.businessUnitList.filter(businessUnit => businessUnit.id === buId)[0].leaderBU;
          arrayOfLeadersId.push(leader.id);
        });

        this.formCreateProject.projectTeamId = [...new Set(arrayOfLeadersId)]
      },
      handleSelectTeamBu(businessUnitId, leaderBu) {
        console.log('leaderbu', leaderBu);
        const even = (element) => element === businessUnitId;
        const ifBuInTeam = this.formCreateProject.projectTeamBuId.some(even);

        // check if removed bu selected for leader
        if (!ifBuInTeam && this.formCreateProject.businessUnitId === businessUnitId) {
          this.formCreateProject.businessUnitId = null;
          this.formCreateProject.projectLeaderId = null;
        }

        if(!ifBuInTeam) {
          // need to check if selected team still have the same leader
          this.formCreateProject.projectTeamId = [];

          let arrayOfLeadersId = [];

          this.formCreateProject.projectTeamBuId.forEach(buId => {
            const leader = this.formCreateProject.businessUnitList.filter(businessUnit => businessUnit.id === buId)[0].leaderBU;
            arrayOfLeadersId.push(leader.id);
            console.log('leader',leader)
          });

          this.formCreateProject.projectTeamId = [...new Set(arrayOfLeadersId)]

          // this.formCreateProject.projectTeamId.forEach((managerId, index) => {
          //   if (managerId === leaderBu.id) {
          //     this.formCreateProject.projectTeamId.splice(index, 1)
          //   }
          // })

        }else {
          const even = (element) => element === leaderBu.id;
          const ifLeaderInTeam = this.formCreateProject.projectTeamId.some(even);
          if(!ifLeaderInTeam) {
            this.formCreateProject.projectTeamId.push(leaderBu.id)
          }
        }
      },
      removeTag(userId){
        if(this.formCreateProject.projectLeaderId === userId) {
          this.formCreateProject.projectLeaderId = null;
          this.formCreateProject.businessUnitId = ''
        }
      },
      handleSelectTeam(userId){
        const even = (element) => element === userId;
        const ifUserInTeam = this.formCreateProject.projectTeamId.some(even);
        if(!ifUserInTeam && this.formCreateProject.projectLeaderId === userId) {
          this.formCreateProject.projectLeaderId = null;
          this.formCreateProject.businessUnitId = ''
        }
      },
      modalCancel(ref) {
        this.$refs[ref].close();
      },
      close(){
        this.formCreateProject.projectTypeId = '';
        this.activeIndex = 0;
        this.formCreateProject.projectName = '';
        this.formCreateProject.Date = [];
        this.formCreateProject.aboutThisProject = null;
        this.formCreateProject.region = '';
        this.formCreateProject.projectStage = '';
        this.formCreateProject.projectPriority = '';
        this.formCreateProject.projectStatus = '';
        this.formCreateProject.country = '';
        this.formCreateProject.projectLeader = '';
        this.formCreateProject.projectLeaderId = '';
        this.formCreateProject.projectTeamId = [];
        this.formCreateProject.projectTeam = [];
        this.formCreateProject.projectTeamBuId = [];
        this.formCreateProject.businessUnitListLeader = [];
        this.formCreateProject.projectTemplates = [{
          name: this.$t('modal_createProject_buildNewTaskTree'),
          id: '0'
        }];
        this.formCreateProject.projectTemplateId = '0';
        this.formCreateProject.projectClientsId = [];
        this.formCreateProject.projectVendorsId = [];
        this.formCreateProject.projectNo = '';
        this.formCreateProject.countryId = null;
        this.formCreateProject.country = [];
        this.formCreateProject.stateId = null;
        this.formCreateProject.state = [];
        this.formCreateProject.cityId = null;
        this.formCreateProject.cities = [];
        this.formCreateProject.street = null;
        this.formCreateProject.postCode = null;
        this.formCreateProject.notifyTeam = true;
        this.formCreateProject.notifyClients = false;
        this.formCreateProject.notifyVendors = false;
        this.formCreateProject.notifyPartners = false;
        this.formCreateProject.address = '';
        this.formCreateProject.address2 = '';
        this.formCreateProject.address3 = '';
        this.formCreateProject.isAddressAssigned = false;
        this.formCreateProject.businessUnitList = [];
        this.formCreateProject.businessUnitName = '';
        this.formCreateProject.projectClients = [];
        this.formCreateProject.projectPriorityId = '';
        this.formCreateProject.projectStageId = '';
        this.formCreateProject.projectStatusId = '';
        this.formCreateProject.projectVendors = [];
        this.templateImgSrc = 'https://dev.totalflow.io/downloads/2020/12/17/849f4ea59c2b133d16c6a0489ebdc9fc.png';
        if(this.projectState === 'add'){
          this.$refs.wizard.navigateToTab(0)
        }
      },
      notification(title, message, type) {
        this.$notify({
          title: title,
          message: message,
          type: type
        });
      }
    }
  }
</script>

<style lang="less" scoped>
    /deep/.wizard-header{
        display:none;
    }
    /deep/.vue-form-wizard .wizard-nav-pills{
        display:none;
    }
    /deep/.wizard-progress-with-circle {
        display:none;
    }
    /deep/.el-range-separator{
      position:relative;
      &::before{
        color: #C0C4CC;
        font-family: "element-icons" !important;
        position:absolute;
        content: "\E78E";
        left: 5px;
        font-size: 14px;
        font-weight: 400;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
      }
    }
    .modal {
        &__time {
            position: absolute;
            top: 32px;
            left: 32px;
            color: #ccc;
        }
        &__title {
            text-align: center;
        }
        &__content {
            max-height: 400px;
            overflow: auto;
        }
        &__btnDesc {
            display: flex;
            justify-content: flex-end;
            margin-bottom: 15px;
        }
        &__btn {
            text-align: right;
        }
    }
    .permissions {
      font-size: 20px;
    }
</style>
